/* eslint-disable import/extensions */

import React from 'react';
import {
    createRoot
} from 'react-dom/client';

import {
    QueryClient, QueryClientProvider
} from 'react-query';

import RIQErrorBoundary from '../../../components/RIQErrorBoundary.jsx';

import {
    ConfigurationProvider
} from '../../../hooks/widgetConfiguration.js';

import ExportContext from '../../../contexts/exportContext.js';
import AccountContext from '../../../contexts/accountContext.js';
import LandscapeContext from '../../../contexts/landscapeContext.js';
import PlanContext from '../../../contexts/planContext.js';
import UserContext from '../../../contexts/userContext.js';

RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const queryClient = new QueryClient();

    // This component is a bridge between Marionette and the React-based company set manager.
    views.ReactCurationLayout = App.views.Layout.mixin({
        className: 'react-curation-bridge',

        template: false,

        regions: {},

        showActions: _.noop,
        onBeforeRenderLoaded: _.noop,
        onRender: function () {
            const me = this;
            const props = me.getProps();

            const element = (
                <React.StrictMode>
                    <RIQErrorBoundary>
                        <QueryClientProvider client={queryClient}>
                            {me.wrapWithStateContexts(me.getComponent(props))}
                        </QueryClientProvider>
                    </RIQErrorBoundary>
                </React.StrictMode>
            );

            if (!me.reactRoot) {
                me.reactRoot = createRoot(me.el);
            }

            me.reactRoot.render(element);
        },

        wrapWithStateContexts: function (child) {
            return (
                <ExportContext.Provider value={RivalIQ.state.view.isExport()}>
                    <AccountContext.Provider value={RivalIQ.state.account.attributes}>
                        <PlanContext.Provider value={RivalIQ.state.plan.attributes}>
                            <UserContext.Provider value={RivalIQ.state.user.attributes}>
                                <LandscapeContext.Provider value={RivalIQ.state.landscape.attributes}>
                                    {child}
                                </LandscapeContext.Provider>
                            </UserContext.Provider>
                        </PlanContext.Provider>
                    </AccountContext.Provider>
                </ExportContext.Provider>
            );
        },

        onDestroy: function () {
            const me = this;

            me.reactRoot?.unmount();
            me.reactRoot = null;
        },

        getComponent: function (props) {
            const me = this;
            const curationId = me.getProp('curation_id');

            const type = App.data.curationMapping[curationId];
            if (!type) {
                throw new Error(`no curation mapping component for '${curationId}'`);
            }

            const component = React.createElement(type, props);
            return component;
        }
    });

    views.ReactWidgetLayout = views.ReactCurationLayout.extend({
        className: 'react-widget-bridge',
        getComponent: function (props) {
            const me = this;
            const dashboardModel = me.dashboardModel;
            const widgetId = dashboardModel.widgetId;

            const type = App.data.widgetMapping[widgetId];
            if (!type) {
                throw new Error(`no widget mapping component for '${widgetId}'`);
            }

            const configurationSchema = {};
            const defaultProps = dashboardModel.configuration.getProps();

            const widgetProps = _.defaults(props, {
                instanceId: dashboardModel.instanceId
            });

            return (
                <ConfigurationProvider
                    configurationSchema={configurationSchema}
                    defaultProps={defaultProps}
                >
                    {React.createElement(type, widgetProps)}
                </ConfigurationProvider>
            );
        }
    });

});
